var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-button",
        { attrs: { variant: "primary" }, on: { click: _vm.openFileExplorer } },
        [_vm._v(" Seleccionar ")]
      ),
      _c(
        "b-modal",
        {
          ref: "filesModal",
          attrs: {
            "hide-footer": "",
            centered: "",
            "no-close-on-backdrop": "",
            title: "Archvios en carpeta",
            size: "xl"
          }
        },
        [
          _c("div", { staticClass: "row mb-5" }, [
            _c("div", { staticClass: "col-9 scroll" }, [
              _c("h5", { staticClass: "mb-5" }, [_vm._v("Archivos")]),
              _c(
                "ul",
                _vm._l([], function(item) {
                  return _c(
                    "li",
                    {
                      key: item.id,
                      staticClass: "cursor-default mb-1 d-flex flex-row"
                    },
                    [
                      item.type === "folder"
                        ? _c("font-awesome-icon", {
                            staticClass: "orange mt-1",
                            attrs: { icon: ["fas", "folder"] }
                          })
                        : _vm._e(),
                      item.type === "file"
                        ? _c("font-awesome-icon", {
                            staticClass: "mt-1",
                            class: _vm.fileTypeIcon(item),
                            attrs: { icon: ["fas", _vm.fileTypeIcon(item)] }
                          })
                        : _vm._e(),
                      _c("span", { staticClass: "ml-2" }, [
                        _vm._v(_vm._s(item.name))
                      ]),
                      _c("span", [_vm._v(" - " + _vm._s(item.owner))])
                    ],
                    1
                  )
                }),
                0
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }